import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';

function buildRedirectToHome(router: Router): UrlTree {
	return router.createUrlTree(['/infos/pets']);
}

export const redirectIfAuthedGuard: CanActivateFn = (route) => {
	const auth = inject(AuthService);
	const router = inject(Router);

	const token = auth.getToken();
	if (!token) return true;

	const path = String(route.routeConfig?.path || '')
		.trim()
		.toLowerCase();
	if (path === 'accept-invite' || path === 'reject-invite') return true;

	return buildRedirectToHome(router);
};
